module.exports = __webpack_public_path__ + "static/testimonial_xs-c2d34794b938b5e0f793c5ef4056172c.jpg";